import { useState, useEffect } from 'react';
import BookingHeader from './booking-header.jsx';
import BookingPage from './booking-page';
import "../../../styles/Auth/booking.css";
const Booking = () => {
    const [filters, setFilters] = useState({});
    const handleApplyFilters = (newFilters) => {
        setFilters(newFilters);
    };
    return (
        <div className='booking-layout'>
            <div className='booking-content'>
                <main className='booking-main'>
                    <BookingHeader onApplyFilters={handleApplyFilters} />
                </main>
                <div className='booking-body'>
                    <BookingPage filters={filters} />
                </div>
            </div>
        </div>
    );
};

export default Booking;